import { TABLET_WIDTH } from '../constants';
const isDeviceDesktop = () => typeof window !== 'undefined' ? window.innerWidth > TABLET_WIDTH : false;
export default isDeviceDesktop;
//# sourceMappingURL=is-device-desktop.js.map